import { Box, BoxProps, ColorOptions, RadioButton, RadioButtonProps, TextProps } from '@jfs/ui-new'
import { useState } from 'react'
import { Button } from '../../comps/Button'
import { useStores } from '../../data/store'
import { convertHexToRGBA } from '../../utils'

interface SelectTenureCardlessProps {
  data: any
  onEmiTenureSubmit: any
}
export const SelectTenureCardless = ({ data, onEmiTenureSubmit }: SelectTenureCardlessProps) => {
  const { theme } = useStores((root) => ({
    theme: root.config.merchantTheme,
  }))
  const [selectedCardLessEmi, setSelectedCardLessEmi] = useState<any>({})
  const style = styles(theme)

  return (
    <>
      <Box {...style.radioGroupContainer}>
        {data.map((item: any) => (
          <SelectTanureItem
            item={item}
            selectedCardLessEmi={selectedCardLessEmi}
            onItemSelected={setSelectedCardLessEmi}
            style={style}
          />
        ))}
      </Box>
      <Box {...style.bottonContainer}>
        <Button
          onPress={() => onEmiTenureSubmit(selectedCardLessEmi.data[0])}
          disabled={!selectedCardLessEmi || !selectedCardLessEmi?.header?.tenure}
          isFull
          title="Proceed"
        />
      </Box>
    </>
  )
}

const SelectTanureItem = ({ item, selectedCardLessEmi, onItemSelected, style }: any) => {
  const isSelected = selectedCardLessEmi?.header?.tenure === item?.header?.tenure
  return (
    <>
      <Box {...style.selectTenureContainer}>
        <RadioButton
          {...style.radioButtonStyle(isSelected)}
          onChange={() => onItemSelected(item)}
          textLabel={item.header.tenure}
        />
      </Box>
      <Box {...style.separatorStyle} />
    </>
  )
}

const styles = (theme: any) => ({
  radioGroupContainer: {
    flex: 1,
    overflow: 'scroll',
  } as BoxProps,
  bottonContainer: {
    marginVertical: 24,
    marginHorizontal: 16,
  } as BoxProps,
  separatorStyle: {
    height: 1,
    backgroundColor: convertHexToRGBA(theme?.bodyTextColor, 10) as ColorOptions,
  } as BoxProps,
  radioButtonStyle: ((isSelected: boolean) => ({
    textSize: 14,
    size: 18,
    fontFamily: isSelected ? 'jioType-bold' : 'jioType-medium',
    color: (isSelected ? theme.brandColor : convertHexToRGBA(theme.bodyTextColor, 60)) as ColorOptions,
    textColor: (isSelected ? theme.brandColor : convertHexToRGBA(theme.bodyTextColor, 60)) as ColorOptions,
    checked: isSelected,
  })) as RadioButtonProps,
  selectTenureContainer: {
    p: 8,
  } as BoxProps,
  buttonText: { fontSize: 14, fontFamily: 'jioType-medium', color: theme.headingText } as TextProps,
})
